/* NOIRÉ theme JS — no dependencies */
(function(){
  "use strict";
  var $  = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var N  = window.NOIRE || {routes:{}, strings:{}};
  /* made-to-order materials (925 silver): everything in that material is a custom order with a lead time */
  function mtoMaterials(){ return ((N.mto && N.mto.materials) || "925 Sterling Silver").split(",").map(function(x){ return x.trim().toLowerCase(); }).filter(Boolean); }
  function isMtoText(t){ t = String(t || "").toLowerCase(); return mtoMaterials().some(function(m){ return t.indexOf(m) > -1; }); }
  /* the lead time belongs to the product, not to whichever page is open: a quick-add from
     somewhere else, or the cart safety net, must not stamp on the page's own number */
  function mtoWeeks(handle){
    var by = (N.mto && N.mto.byHandle) || {};
    if(handle && by[handle] > 0) return by[handle];
    if(!handle){
      var pdp = document.getElementById("pdp"), w = pdp && parseInt(pdp.getAttribute("data-mto-weeks"), 10);
      if(w > 0) return w;
    }
    return (N.mto && N.mto.weeks) || 2;
  }
  function mtoProp(handle){ var w = mtoWeeks(handle); return "Ships In " + w + " Week" + (w === 1 ? "" : "s"); }
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  /* ---------- money (Shopify money_format) ---------- */
  function money(cents){
    var fmt = N.moneyFormat || "${{amount}}";
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : "amount";
    var n = (cents || 0) / 100, out;
    function sep(v, d, t, dec){ var s = v.toFixed(d); var p = s.split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return dec && p[1] ? p.join(dec) : p[0]; }
    switch(key){
      case "amount_no_decimals": out = sep(n, 0, ","); break;
      case "amount_with_comma_separator": out = sep(n, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": out = sep(n, 0, "."); break;
      case "amount_with_apostrophe_separator": out = sep(n, 2, "'", "."); break;
      default: out = sep(n, 2, ",", ".");
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, "");
  }

  /* ---------- announcement rotator ---------- */
  (function(){
    var host = $("#announce"); if(!host) return;
    var slides = $$(".slide", host); if(slides.length < 2) return;
    if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var i = 0, every = parseInt(host.getAttribute("data-interval"), 10) || 3400;
    setInterval(function(){
      var cur = slides[i], nxt = slides[(i+1) % slides.length];
      cur.classList.remove("on"); cur.classList.add("out");
      nxt.classList.remove("out"); nxt.classList.add("on");
      setTimeout(function(){ cur.classList.remove("out"); }, 500);
      i = (i+1) % slides.length;
    }, every);
  })();

  /* ---------- scrim helpers ---------- */
  var scrim = $("#scrim");
  function scrimOn(){ if(scrim) scrim.classList.add("on"); }
  function scrimOff(){ if(scrim) scrim.classList.remove("on"); }

  /* ---------- nav drawer ---------- */
  (function(){
    var d = $("#navdrawer"), open = $("#navOpen"), close = $("#navClose");
    if(!d || !open) return;
    function show(){ d.classList.add("on"); scrimOn(); open.setAttribute("aria-expanded","true"); document.body.classList.add("nav-open"); }
    function hide(){ d.classList.remove("on"); document.body.classList.remove("nav-open"); open.setAttribute("aria-expanded","false"); if(!$("#drawer.on")) scrimOff(); }
    open.addEventListener("click", show);
    if(close) close.addEventListener("click", hide);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") hide(); });
    if(scrim) scrim.addEventListener("click", hide);
  })();

  /* ---------- search (predictive) ---------- */
  (function(){
    var box = $("#search"), inp = $("#searchInput"), res = $("#searchRes"), openB = $("#searchOpen"), closeB = $("#searchClose");
    if(!box || !inp) return;
    var t;
    function card(p){
      return '<a class="card" href="' + esc(p.url) + '"><div class="ph">' + (p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '&width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') +
             '</div><div class="info"><h3>' + esc(p.title) + '</h3><p class="price"><small>from</small>' + esc(money(p.price_min * 100)) + '</p></div></a>';
    }
    function draw(){
      var q = inp.value.trim();
      if(!q){ res.innerHTML = ""; return; }
      var url = (N.routes.predictiveSearch || "/search/suggest") + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title";
      fetch(url).then(function(r){ return r.json(); }).then(function(j){
        var list = (j.resources && j.resources.results && j.resources.results.products) || [];
        res.innerHTML = '<p class="hint">' + list.length + ' result' + (list.length === 1 ? '' : 's') + '</p>' +
          (list.length ? '<div class="grid">' + list.map(card).join("") + '</div>' : '<p class="empty">Nothing matches that.</p>');
      }).catch(function(){ res.innerHTML = ""; });
    }
    function show(){ box.classList.add("on"); setTimeout(function(){ inp.focus(); }, 30); }
    function hide(){ box.classList.remove("on"); }
    openB && openB.addEventListener("click", show);
    box.addEventListener("click", function(e){ if(e.target === box) hide(); });
    closeB && closeB.addEventListener("click", hide);
    inp.addEventListener("input", function(){ clearTimeout(t); t = setTimeout(draw, 180); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") hide(); });
  })();


  /* ---------- email signup (footer Early access + members pop-up): Klaviyo list + Shopify customer + sheet ---------- */
  (function(){
    var KL = N.klaviyo || {}; if(!KL.company) return;
    var SHEET = KL.sheet || "";
    function subscribe(email, source){
      var calls = [];
      calls.push(fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(KL.company), {
        method:"POST", headers:{"Content-Type":"application/vnd.api+json", "revision":"2026-07-15"},
        body:JSON.stringify({data:{type:"subscription", attributes:{custom_source:source, profile:{data:{type:"profile", attributes:{email:email, subscriptions:{email:{marketing:{consent:"SUBSCRIBED"}}}}}}}, relationships:{list:{data:{type:"list", id:KL.list}}}}})
      }).catch(function(){}));
      if(SHEET){ var i = new Image(); i.src = SHEET + "?source=" + encodeURIComponent(source) + "&email=" + encodeURIComponent(email) + "&t=" + Date.now(); }
      return Promise.all(calls);
    }
    document.addEventListener("submit", function(e){
      var f = e.target.closest("form[data-source]"); if(!f) return;
      var inp = f.querySelector('input[type="email"]'); if(!inp) return;
      e.preventDefault();
      var email = (inp.value || "").trim(); if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ inp.focus(); inp.setAttribute("aria-invalid", "true"); return; }
      if(f.getAttribute("data-busy")) return; f.setAttribute("data-busy", "1");
      var btn = f.querySelector('button[type="submit"]'); if(btn) btn.disabled = true;
      subscribe(email, f.getAttribute("data-source") || "Website").then(function(){ // Klaviyo is the list of record (its Shopify integration syncs the profile to Shopify)
        var ok = f.querySelector("[data-ok]"); var row = f.querySelector(".fnews-row");
        if(row) row.hidden = true; if(ok) ok.hidden = false;
        f.dispatchEvent(new CustomEvent("noire:subscribed", {bubbles:true}));
      });
    });
  })();

  /* ---------- recent purchase toast ("Just purchased"), fed by the Cloudflare worker; same timing as the old site ---------- */
  (function(){
    var toast = document.getElementById("buyToast"); if(!toast) return;
    var ENDPOINT = toast.getAttribute("data-endpoint"); if(!ENDPOINT) return;
    var SILVER_WEIGHT = 0.8, VISIBLE_MS = 4500, GAP_MIN_MS = 3000, GAP_MAX_MS = 120000, FIRST_SHOW_MS = 7000, MAX_PER_SESSION = 4;
    var textEl = toast.querySelector(".bt-text"), locEl = toast.querySelector(".bt-loc"), thumbEl = toast.querySelector("img"), closeBtn = toast.querySelector(".bt-x");
    var imgMap = {}; try { imgMap = JSON.parse(toast.getAttribute("data-imgmap") || "{}"); } catch(e){}
    var closedByUser = false, timer = null, silverPool = [], steelPool = [], shown = 0, seen = {};
    var key = function(e){ return e.name + "|" + e.product + "|" + e.loc; };
    var gap = function(){ return Math.floor(GAP_MIN_MS + Math.random() * (GAP_MAX_MS - GAP_MIN_MS)); };
    function cutout(e){ // our transparent shot for that product + material, else the worker's image
      var t = String(e.product || "").toLowerCase(), hit = null;
      Object.keys(imgMap).forEach(function(title){ if(!hit && t.indexOf(title) > -1) hit = imgMap[title]; });
      if(!hit) return e.image ? (e.image.indexOf("//") === 0 ? "https:" + e.image : e.image) : "";
      var fin = /distress/i.test(e.material || "") ? "distressed" : "polished";
      return hit[fin] || hit._ || "";
    }
    function pick(){
      var s = silverPool.filter(function(e){ return !seen[key(e)]; }), t = steelPool.filter(function(e){ return !seen[key(e)]; });
      var useSilver = s.length && (Math.random() < SILVER_WEIGHT || !t.length); var pool = useSilver ? s : t;
      return pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
    }
    function show(){
      if(closedByUser || shown >= MAX_PER_SESSION) return;
      if(document.body.classList.contains("pop-open") || document.body.classList.contains("nav-open")){ timer = setTimeout(show, 4000); return; } // never over the email pop-up or the menu
      var e = pick(); if(!e) return; seen[key(e)] = true; shown++;
      textEl.textContent = e.name + " bought the " + e.product + ": " + e.material;
      locEl.textContent = e.loc || "";
      var src = cutout(e); if(src){ thumbEl.src = src; thumbEl.hidden = false; } else thumbEl.hidden = true;
      toast.classList.add("on");
      timer = setTimeout(function(){ toast.classList.remove("on"); if(!closedByUser && shown < MAX_PER_SESSION) timer = setTimeout(show, gap()); }, VISIBLE_MS);
    }
    closeBtn.addEventListener("click", function(){ closedByUser = true; toast.classList.remove("on"); clearTimeout(timer); });
    // only the product/material pairs the theme setting names reach the pop-up
    var ONLY = (toast.getAttribute("data-only") || "").split("\n").map(function(line){
      var bits = line.split("|");
      return bits.length > 1 ? {p: bits[0].trim().toLowerCase(), m: bits[1].trim().toLowerCase()} : null;
    }).filter(Boolean);
    function allowed(e){
      if(!ONLY.length) return true;
      var pr = String(e.product || "").toLowerCase(), mt = String(e.material || "").toLowerCase();
      return ONLY.some(function(o){ return pr.indexOf(o.p) > -1 && mt.indexOf(o.m) > -1; });
    }
    fetch(ENDPOINT).then(function(r){ return r.ok ? r.json() : []; }).then(function(list){
      if(!Array.isArray(list) || !list.length) return;
      list = list.filter(allowed);
      if(!list.length) return;
      silverPool = list.filter(function(e){ return e.metal === "silver"; }); steelPool = list.filter(function(e){ return e.metal === "steel"; });
      if(silverPool.length || steelPool.length) timer = setTimeout(show, FIRST_SHOW_MS);
    }).catch(function(){});
  })();
  /* ---------- lightbox ---------- */
  (function(){
    var lb = $("#lightbox"), img = $("#lbImg"); if(!lb) return;
    document.addEventListener("click", function(e){
      var b = e.target.closest(".rvphoto");
      if(b){
        var full = b.getAttribute("data-full"), thumb = $("img", b);
        img.src = (thumb && thumb.currentSrc) || full; // the thumbnail is already decoded: show it now
        lb.classList.add("on");
        var hi = new Image();
        hi.onload = function(){ if(lb.classList.contains("on")) img.src = full; };
        hi.src = full;
        return;
      }
      if(e.target.closest("#lbClose") || e.target === lb) lb.classList.remove("on");
    });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") lb.classList.remove("on"); });
    // warm the full-size image before the tap lands
    var warmed = {};
    function warm(e){ var b = e.target.closest && e.target.closest(".rvphoto"); if(!b) return; var f = b.getAttribute("data-full"); if(!f || warmed[f]) return; warmed[f] = 1; var i = new Image(); i.src = f; }
    document.addEventListener("pointerover", warm, {passive:true});
    document.addEventListener("touchstart", warm, {passive:true});
    // and quietly pre-fetch the ones on screen once the page is idle
    (window.requestIdleCallback || function(fn){ setTimeout(fn, 1200); })(function(){
      if(!("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(!x.isIntersecting) return; var f = x.target.getAttribute("data-full"); if(f && !warmed[f]){ warmed[f] = 1; var i = new Image(); i.src = f; } io.unobserve(x.target); }); }, {rootMargin:"600px"});
      $$(".rvphoto").forEach(function(b){ io.observe(b); });
    });
  })();


  /* ---------- live review stats: every count/average on the site is derived from the review blocks ---------- */
  (function(){
    function statsFrom(root){
      var cards = $$(".rv:not(.rv-skel)", root); if(!cards.length) return null;
      var total = 0, sum = 0, per = {};
      cards.forEach(function(c){
        var st = $(".stars", c), r = st ? (st.textContent.match(/★/g) || []).length : 5;
        var p = (c.getAttribute("data-product") || "").trim().toLowerCase();
        total++; sum += r; if(p){ per[p] = per[p] || {n:0, s:0}; per[p].n++; per[p].s += r; }
      });
      return {total:total, avg:(Math.round(sum / total * 10) / 10).toFixed(1), per:per};
    }
    function apply(st){
      if(!st) return;
      $$("[data-rv-total]").forEach(function(e){ e.textContent = String(st.total); });
      $$("[data-rv-avg]").forEach(function(e){ e.textContent = st.avg; });
      $$("[data-rv-text]").forEach(function(e){ e.innerHTML = e.getAttribute("data-rv-text").replace(/\[avg\]/g, st.avg).replace(/\[count\]/g, String(st.total)); });
      $$("[data-rv-pcount]").forEach(function(e){ var k = e.getAttribute("data-rv-pcount"); var p = st.per[k]; if(!p && /cuban set/.test(k)){ var a = st.per["cuban chain"], b = st.per["cuban bracelet"]; if(a || b) p = {n:(a?a.n:0)+(b?b.n:0), s:(a?a.s:0)+(b?b.s:0)}; } if(p) e.textContent = String(p.n); });
      $$("[data-rv-pavg]").forEach(function(e){ var k = e.getAttribute("data-rv-pavg"); var p = st.per[k]; if(!p && /cuban set/.test(k)){ var a = st.per["cuban chain"], b = st.per["cuban bracelet"]; if(a || b) p = {n:(a?a.n:0)+(b?b.n:0), s:(a?a.s:0)+(b?b.s:0)}; } if(p && p.n) e.textContent = (Math.round(p.s / p.n * 10) / 10).toFixed(1); });
    }
    window.NOIRE_applyReviewStats = function(root){ var st = statsFrom(root); if(st){ apply(st); try { sessionStorage.setItem("noire_rv", JSON.stringify({t:Date.now(), s:st})); } catch(e){} } };
    var local = statsFrom(document);
    if(local){ apply(local); try { sessionStorage.setItem("noire_rv", JSON.stringify({t:Date.now(), s:local})); } catch(e){} return; }
    var need = $$("[data-rv-total],[data-rv-avg],[data-rv-text],[data-rv-pcount],[data-rv-pavg]").length; if(!need) return;
    var sid = N.reviewsSection; if(!sid) return;
    if($(".reviews[data-source='home']")) return; // the mirror fill applies the stats itself
    fetch("/?section_id=" + encodeURIComponent(sid), {cache:"no-cache"}).then(function(r){ return r.ok ? r.text() : ""; }).then(function(html){
      if(!html) return; var box = document.createElement("div"); box.innerHTML = html;
      var st = statsFrom(box); if(st){ apply(st); try { sessionStorage.setItem("noire_rv", JSON.stringify({t:Date.now(), s:st})); } catch(e){} }
    }).catch(function(){});
  })();
  /* ---------- reviews: filter chips + show more ---------- */
  function initReviews(sec){
    var cards = $$(".rv:not(.rv-skel)", sec), chips = $(".rvchips", sec), more = $(".rvmore", sec);
    if(!cards.length || !chips || sec.getAttribute("data-rv-ready")) return;
    sec.setAttribute("data-rv-ready", "1");
    var counts = {}, label = {};
    // group case-insensitively so "Wings Ring" and "WINGS Ring" are one chip
    cards.forEach(function(c){ var raw = (c.getAttribute("data-product") || "").trim(), p = raw.toLowerCase(); if(!p) return; c.setAttribute("data-product", p); if(!label[p]) label[p] = raw; counts[p] = (counts[p]||0) + 1; });
    var order = Object.keys(counts).sort(function(a,b){ return counts[b] - counts[a]; });
    var def = sec.getAttribute("data-default") || "*";
    // a product can map to several review groups ("CUBAN Chain|CUBAN Bracelet" for the set): a combined chip is added for it
    var defs = def.split("|").map(function(d){ return order.filter(function(p){ return p === d.trim().toLowerCase(); })[0]; }).filter(Boolean);
    var match = defs.length > 1 ? defs.join("|") : defs[0];
    if(defs.length > 1){ counts[match] = defs.reduce(function(a, p){ return a + counts[p]; }, 0); }
    var withPhotos = cards.filter(function(c){ return !!$(".rvphoto", c); }).length;
    function hits(k){ if(k === "@photos") return function(c){ return !!$(".rvphoto", c); }; var set = k.split("|"); return function(c){ return set.indexOf(c.getAttribute("data-product") || "") > -1; }; }
    var active = "*"; // always open on "All reviews"; the product's own chip is there to click
    var step = parseInt(sec.getAttribute("data-initial"), 10) || 9, shown = step;
    var cf = $("[data-count-for]", sec); if(cf) cf.textContent = String(counts[match] || 0);
    function draw(){
      var list = [{k:"*", l:"All reviews", n:cards.length}];
      if(defs.length > 1) list.push({k:match, l:sec.getAttribute("data-default-label") || "This piece", n:counts[match]});
      chips.innerHTML = list.concat(order.map(function(p){ return {k:p, l:label[p], n:counts[p]}; }))
        .map(function(f){ return '<button type="button" data-k="' + esc(f.k) + '" aria-pressed="' + (f.k === active) + '">' + esc(f.l) + ' (' + f.n + ')</button>'; }).join("");
      var n = 0, isHit = hits(active);
      cards.forEach(function(c){
        var ok = active === "*" || isHit(c);
        var vis = ok && n < shown; if(ok) n++;
        c.hidden = !vis;
      });
      var total = active === "*" ? cards.length : active === "@photos" ? withPhotos : counts[active] || 0;
      more.innerHTML = total > shown ? '<button type="button">Show ' + Math.min(12, total - shown) + ' more</button>' : "";
    }
    chips.addEventListener("click", function(e){ var b = e.target.closest("button"); if(!b) return; active = b.getAttribute("data-k"); shown = step; draw(); });
    more.addEventListener("click", function(e){ if(!e.target.closest("button")) return; shown += 12; draw(); });
    draw();
  }
  $$(".reviews:not([data-source])").forEach(initReviews);
  /* sections that mirror the homepage reviews: pull that section's markup once (cached 10 min) and drop the cards in */
  (function(){
    var mirrors = $$(".reviews[data-source='home']"); if(!mirrors.length || !N.reviewsSection) return;
    function fill(html){
      var box = document.createElement("div"); box.innerHTML = html; var src = $(".rvgrid", box); if(!src) return;
      mirrors.forEach(function(sec){ var g = $(".rvgrid", sec); if(g){ g.innerHTML = src.innerHTML; } initReviews(sec); });
      if(window.NOIRE_applyReviewStats) window.NOIRE_applyReviewStats(document);
    }
    // always fresh: an edit on the homepage must show on the product pages straight away.
    // the section id belongs to the homepage template and changes with every theme copy, so when it
    // comes back empty we read the homepage itself instead.
    function grab(url){ return fetch(url, {cache:"no-cache"}).then(function(r){ return r.ok ? r.text() : ""; }).catch(function(){ return ""; }); }
    grab("/?section_id=" + encodeURIComponent(N.reviewsSection)).then(function(html){
      return (html && html.indexOf("rvgrid") > -1) ? html : grab("/");
    }).then(function(html){ if(html) fill(html); });
  })();

  /* ---------- collection: built-in category tabs (filter the grid in place, no reload) ---------- */
  (function(){
    var tabs = $("#catTabs"); if(!tabs) return;
    var cards = $$(".grid .card");
    function apply(want, push){
      want = (want || "").toLowerCase();
      $$("a", tabs).forEach(function(a){ a.classList.toggle("on", (a.getAttribute("data-filter") || "") === want); });
      var hits = 0;
      cards.forEach(function(c){
        var t = (c.getAttribute("data-type") || "");
        var ok = !want ? true : want === "new" ? c.getAttribute("data-new") === "true"
          : t.indexOf(want.replace(/s$/, "")) > -1 || (want === "chains" && /pendant|chain|set/.test(t));
        if(ok) hits++;
        c.hidden = !ok;
      });
      if(!hits) cards.forEach(function(c){ c.hidden = false; }); // nothing typed yet in Shopify: show everything rather than an empty page
      if(push && history.replaceState){
        var u = new URL(location.href); if(want) u.searchParams.set("filter", want); else u.searchParams.delete("filter");
        history.replaceState(null, "", u.pathname + u.search);
      }
    }
    tabs.addEventListener("click", function(e){
      var a = e.target.closest("a[data-filter]"); if(!a) return;
      e.preventDefault(); apply(a.getAttribute("data-filter"), true);
    });
    apply(new URLSearchParams(location.search).get("filter") || "new", false); // opens on New Arrivals unless a filter was asked for in the link
  })();

  /* ---------- quick eased scroll (faster than native smooth) + in-page anchors ---------- */
  function scrollToY(target, ms){
    var start = window.scrollY, dist = target - start, t0 = null; ms = ms || 380;
    if(Math.abs(dist) < 2) return;
    t0 = performance.now();
    (function step(){ var p = Math.min(1, (performance.now() - t0) / ms); var e = 1 - Math.pow(1 - p, 3); window.scrollTo(0, start + dist * e); if(p < 1) setTimeout(step, 16); })();
  }
  function headerOffset(){ var h = $(".sitehead"); return h ? h.offsetHeight : 0; }
  document.addEventListener("click", function(e){
    var a = e.target.closest('a[href^="#"]'); if(!a || a.hasAttribute("data-modal")) return;
    var id = a.getAttribute("href").slice(1); if(!id) return;
    var el = document.getElementById(id); if(!el) return;
    e.preventDefault();
    scrollToY(el.getBoundingClientRect().top + window.scrollY - headerOffset() - 8, 520);
    if(history.replaceState) history.replaceState(null, "", "#" + id);
  });

  /* ---------- FAQ accordion: animated, one open at a time ---------- */
  $$(".faq").forEach(function(faq){
    faq.addEventListener("click", function(e){
      var sum = e.target.closest("summary"); if(!sum) return;
      e.preventDefault();
      var d = sum.parentElement, wasOn = d.classList.contains("on");
      $$("details.on", faq).forEach(function(x){ x.classList.remove("on"); });
      if(!wasOn) d.classList.add("on");
    });
  });

  /* ---------- modals (size guide) ---------- */
  document.addEventListener("click", function(e){
    var opener = e.target.closest("[data-modal]");
    if(opener){
      var m = document.getElementById(opener.getAttribute("data-modal")); if(!m) return;
      e.preventDefault();
      var body = $(".modal-body", m), tpl = $("#sizeGuideTpl");
      if(body && tpl && !body.childNodes.length){ body.appendChild(tpl.content.cloneNode(true)); bindSizeInputs(body); }
      m.hidden = false; document.body.style.overflow = "hidden";
      var c = $("[data-modal-close]", m); if(c) c.focus();
      return;
    }
    var m2 = e.target.closest(".modal");
    if(m2 && (e.target === m2 || e.target.closest("[data-modal-close]"))){ m2.hidden = true; document.body.style.overflow = ""; }
  });
  document.addEventListener("keydown", function(e){ if(e.key !== "Escape") return; $$(".modal:not([hidden])").forEach(function(m){ m.hidden = true; document.body.style.overflow = ""; }); });

  /* ---------- ring size finder ---------- */
  var SIZES = [{us:"5",eu:49,d:15.7,c:49.3,s:0},{us:"6",eu:52,d:16.5,c:51.8,s:0},{us:"7",eu:54,d:17.3,c:54.3,s:1},{us:"7.5",eu:56,d:17.7,c:55.6,s:0},
    {us:"8",eu:57,d:18.1,c:56.9,s:1},{us:"8.5",eu:58,d:18.5,c:58.1,s:0},{us:"9",eu:60,d:19.0,c:59.7,s:1},{us:"9.5",eu:61,d:19.4,c:60.9,s:0},
    {us:"10",eu:62,d:19.8,c:62.2,s:1},{us:"10.5",eu:63,d:20.2,c:63.5,s:0},{us:"11",eu:64,d:20.6,c:64.7,s:0},{us:"11.5",eu:66,d:21.0,c:66.0,s:0},{us:"12",eu:67,d:21.4,c:67.2,s:0}];
  function bindSizeInputs(scope){ $$(".size-input", scope || document).forEach(bindSizeInput); }
  /* Real stock per material for a US size: the product on this page if it has sizes, otherwise the Faith Ring (fetched once). */
  var sizeStockProduct = null, sizeStockPending = null;
  function sizeStockSource(){
    if(sizeStockProduct) return Promise.resolve(sizeStockProduct);
    var pdp = $("#pdp"), p = null;
    if(pdp){ try { p = JSON.parse(pdp.getAttribute("data-product")); } catch(e){} }
    if(p && p.options && p.options.some(function(o){ return /size/i.test(o.name || o); })){ sizeStockProduct = p; return Promise.resolve(p); }
    if(!sizeStockPending) sizeStockPending = fetch("/products/faith-ring.js").then(function(r){ return r.json(); }).then(function(j){ sizeStockProduct = j; return j; }).catch(function(){ return null; });
    return sizeStockPending;
  }
  function sizeStockLines(p, us){
    if(!p || !p.variants) return null;
    var names = (p.options || []).map(function(o){ return typeof o === "string" ? o : o.name; });
    var si = names.findIndex(function(n){ return /size/i.test(n); }), mi = names.findIndex(function(n){ return /material/i.test(n); });
    if(si < 0) return null;
    var byMat = {}, order = [];
    p.variants.forEach(function(v){
      var opts = v.options || [v.option1, v.option2, v.option3];
      var mat = mi > -1 ? opts[mi] : "", size = String(opts[si] || "");
      if(!byMat[mat]){ byMat[mat] = {stock:false, custom:false}; order.push(mat); }
      if(new RegExp("^" + us.replace(".", "\\.") + "\\s*us", "i").test(size.trim()) && v.available) byMat[mat].stock = true;
      if(/custom/i.test(size) && v.available) byMat[mat].custom = true;
    });
    var mto = mtoMaterials();
    var mtoText = "custom order, ships in " + mtoWeeks() + " week" + (mtoWeeks() === 1 ? "" : "s");
    return order.map(function(mat){
      var st = byMat[mat], label = mat ? String(mat).replace(/^\s*\d+L\s+/i, "") + ": " : "";
      if(mat && mto.some(function(m){ return String(mat).toLowerCase().indexOf(m) > -1; })){ // silver is always made to order
        return (st.stock || st.custom) ? '<p class="flag">' + esc(label) + esc(mtoText) + '</p>' : '<p class="flag off">' + esc(label) + 'not available in this size</p>';
      }
      if(st.stock) return '<p class="flag">' + esc(label) + 'in stock, ready to ship</p>';
      if(st.custom) return '<p class="flag dim">' + esc(label) + 'made to order. Choose Custom Size and note US ' + esc(us) + '</p>';
      return '<p class="flag off">' + esc(label) + 'sold out in this size</p>';
    }).join("");
  }
  function bindSizeInput(input){
    var out = document.getElementById(input.getAttribute("data-out")); if(!out || input.getAttribute("data-bound")) return;
    input.setAttribute("data-bound", "1");
    function run(){
      var mm = parseFloat(input.value);
      if(isNaN(mm) || mm < 40 || mm > 80){ out.innerHTML = '<p class="rnote">Enter a measurement between 40 mm and 80 mm. That\'s the full adult range.</p>'; return; }
      var best = SIZES[0], bd = 1e9; SIZES.forEach(function(s){ var d = Math.abs(s.c - mm); if(d < bd){ bd = d; best = s; } });
      out.innerHTML = '<div class="big">US ' + best.us + '</div><p class="rnote">' + best.d.toFixed(1) + ' mm inside diameter · EU ' + best.eu +
        (bd > 0.7 ? ' · you measured ' + mm.toFixed(1) + ' mm, so you sit between sizes. Take the larger one.' : '') + '</p><div class="stockrows"></div>';
      var host = $(".stockrows", out), want = best.us;
      sizeStockSource().then(function(p){
        if(!host || !host.isConnected) return;
        var html = sizeStockLines(p, want);
        host.innerHTML = html !== null ? html : (best.s ? '<p class="flag">Stock size</p>' : '<p class="flag dim">Made to order. Choose Custom Size at checkout</p>');
      });
    }
    input.addEventListener("input", run); run();
  }
  bindSizeInputs();

  /* ---------- discount code the theme applies for the customer (bundle offers) ---------- */
  var codeTried = {};
  function applyCode(code){
    if(!code || codeTried[code]) return Promise.resolve(false);
    codeTried[code] = 1;
    return fetch("/discount/" + encodeURIComponent(code), {credentials:"same-origin"}).then(function(){ return true; }).catch(function(){ return false; });
  }
  function bundleCode(){
    var el = $("#pairBundle"); if(!el) return null;
    var code = el.getAttribute("data-code"); if(!code) return null;
    return {code:code, handle:el.getAttribute("data-handle"), min:parseInt(el.getAttribute("data-min"), 10) || 2};
  }
  function maybeApplyBundleCode(cart){
    var cfg = bundleCode(); if(!cfg || !cart || !cart.items) return;
    if(cart.total_discount > 0) return;
    var units = cart.items.reduce(function(a, i){ return a + (i.handle === cfg.handle ? i.quantity : 0); }, 0);
    if(units < cfg.min) return;
    applyCode(cfg.code).then(function(ok){ if(ok) fetchCart(); });
  }

  /* ---------- one-tap add on product cards ---------- */
  document.addEventListener("click", function(e){
    var b = e.target.closest("button.quickadd"); if(!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute("data-variant"), 10); if(!id) return;
    var pv = [previewLine({id:id, price:parseInt(b.getAttribute("data-price"), 10) || 0, title:b.getAttribute("data-vtitle") || ""},
      b.getAttribute("data-title") || "", b.getAttribute("data-img") || "", {}, b.getAttribute("data-handle") || "")];
    addToCart({items:[{id:id, quantity:1}]}, pv);
  });

  /* ---------- cart drawer ---------- */
  var drawer = $("#drawer"), cartHost = $("#cartItems");
  function openCart(){ if(drawer){ drawer.classList.add("on"); scrimOn(); } }
  function closeCart(){ if(drawer){ drawer.classList.remove("on"); if(!$("#navdrawer.on")) scrimOff(); } }
  var cartImgMap = null; // product handle -> { _: cut-out, <finish>: cut-out }
  function lineImage(it){
    if(cartImgMap === null){ try { cartImgMap = JSON.parse(cartHost.getAttribute("data-imgmap") || "{}"); } catch(e){ cartImgMap = {}; } }
    var m = it.handle && cartImgMap[it.handle]; if(!m) return it.image || "";
    var fin = (it.options_with_values || []).filter(function(o){ return /finish/i.test(o.name); })[0];
    return (fin && m[String(fin.value).toLowerCase()]) || m._ || it.image || "";
  }
  function renderCart(cart){
    var units = cart.item_count || 0;
    ["#cartN","#cartCount"].forEach(function(s){ var e = $(s); if(e){ e.textContent = String(units); e.setAttribute("data-z", units ? "0" : "1"); } });
    if(cartHost){
      if(!cart.items || !cart.items.length){ cartHost.innerHTML = '<p class="empty">' + esc(N.strings.empty || "Your cart is empty.") + '</p>'; }
      else {
        cartHost.innerHTML = cart.items.map(function(it){
          // the lead-time note ("Custom Order") is kept off the drawer; it still goes through to checkout and the order
          var props = Object.keys(it.properties || {}).filter(function(k){ return k.charAt(0) !== "_" && k !== "Custom Order"; }).map(function(k){ return " · " + esc(k + ": " + it.properties[k]); }).join("");
          var im = lineImage(it);
          var href = it.url || (it.handle ? "/products/" + it.handle : "");
          var phOpen = href ? '<a class="ph" href="' + esc(href) + '">' : '<div class="ph">', phClose = href ? '</a>' : '</div>';
          var nOpen = href ? '<a class="n" href="' + esc(href) + '">' : '<div class="n">', nClose = href ? '</a>' : '</div>';
          return '<div class="ci" data-key="' + esc(it.key) + '">' + phOpen + (im ? '<img src="' + esc(/[?&]width=/.test(im) ? im : (im.indexOf("?") > -1 ? im + "&width=160" : im + "?width=160")) + '" alt="">' : '') + phClose +
            '<div>' + nOpen + esc(it.product_title) + nClose + '<div class="o">' + esc(it.variant_title || "") + props + '</div>' +
            '<div class="qty"><button type="button" data-d="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-d="1" aria-label="Increase">+</button></div></div>' +
            '<div class="side"><div class="pr">' + esc(money(it.final_line_price)) +
            (it.original_line_price > it.final_line_price ? '<s>' + esc(money(it.original_line_price)) + '</s>' : '') + '</div>' +
            (it.original_line_price > it.final_line_price ? '<div class="lsave">' + esc(N.strings.saved || "Saved") + ' ' + esc(money(it.original_line_price - it.final_line_price)) + '</div>' : '') +
            '<button type="button" class="rm" data-rm="1">' + esc(N.strings.remove || "Remove") + '</button></div></div>';
        }).join("");
        var have = {}; cart.items.forEach(function(i){ have[i.handle] = 1; });
        var cross = [];
        try { cross = JSON.parse(cartHost.getAttribute("data-cross") || "[]"); } catch(e){}
        var offer = cross.filter(function(p){ return !have[p.handle]; }).slice(0,3);
        if(offer.length){
          cartHost.innerHTML += '<div class="cross"><p class="lbl">' + esc(N.strings.alsoBought || "People also bought") + '</p>' +
            offer.map(function(p){ var u = p.handle ? "/products/" + p.handle : ""; return '<div class="xs">' + (u ? '<a class="ph" href="' + esc(u) + '">' : '<div class="ph">') + (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '') + (u ? '</a>' : '</div>') +
              '<div>' + (u ? '<a class="n" href="' + esc(u) + '">' : '<div class="n">') + esc(p.title) + (u ? '</a>' : '</div>') + '<div class="p">from ' + esc(money(p.price)) + '</div></div>' +
              '<button type="button" class="add" data-variant="' + p.variant + '">Add</button></div>'; }).join("") + '</div>';
        }
      }
    }
    var ct = $("#cartTotal"); if(ct) ct.textContent = money(cart.total_price || 0);
    var saved = (cart.original_total_price || cart.total_price || 0) - (cart.total_price || 0);
    if(!saved && cart.items) saved = cart.items.reduce(function(a, i){ return a + ((i.original_line_price || i.final_line_price) - i.final_line_price); }, 0);
    var sr = $("#cartSaveRow"), sv = $("#cartSave");
    if(sr){ sr.hidden = saved <= 0; if(sv && saved > 0) sv.textContent = "-" + money(saved); }
    var co = $("#checkoutBtn");
    if(co){ co.textContent = (N.strings.checkout || "Checkout") + (units ? " · " + money(cart.total_price) + " " + (cart.currency || "") : "");
      co.style.opacity = units ? "" : ".4"; co.style.pointerEvents = units ? "" : "none"; }
  }
  /* Keep the last cart in memory so every action can update the drawer instantly (optimistic),
     then reconcile with Shopify's response. change.js and update.js return the whole cart, so
     they need one round trip; add.js returns the new lines, which are merged in and totals re-summed. */
  var lastCart = null;
  /* safety net: a made-to-order line that reached the cart without its lead time (stale cart, reorder, an app) gets it stamped on */
  var mtoFixing = false;
  function ensureMto(cart){
    if(mtoFixing || !cart || !cart.items) return;
    var miss = cart.items.filter(function(i){
      if(!isMtoText(i.variant_title)) return false;
      var want = "Ships In " + mtoWeeks(i.handle) + " Week" + (mtoWeeks(i.handle) === 1 ? "" : "s");
      return !i.properties || i.properties["Custom Order"] !== want; // missing, or left over from a shorter lead time
    });
    if(!miss.length) return;
    mtoFixing = true;
    var chain = Promise.resolve(null);
    miss.forEach(function(i){
      chain = chain.then(function(){
        var w = mtoWeeks(i.handle);
        var props = {}; Object.keys(i.properties || {}).forEach(function(k){ props[k] = i.properties[k]; });
        props["Custom Order"] = "Ships In " + w + " Week" + (w === 1 ? "" : "s");
        return post(N.routes.cartChange + ".js", {id: i.key, quantity: i.quantity, properties: props});
      });
    });
    chain.then(function(c){ mtoFixing = false; if(c && c.items) renderCartState(c); }, function(){ mtoFixing = false; });
  }
  function renderCartState(c){ lastCart = c; renderCart(c); maybeApplyBundleCode(c); ensureMto(c); return c; }
  function retotal(c){ c.item_count = 0; c.total_price = 0; c.items.forEach(function(i){ c.item_count += i.quantity; c.total_price += i.final_line_price; }); return c; }
  function post(url, body){ return fetch(url, {method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json","Accept":"application/json"}, body:JSON.stringify(body)}).then(function(r){ return r.json(); }); }
  function fetchCart(){ return fetch(N.routes.cart + ".js", {credentials:"same-origin"}).then(function(r){ return r.json(); }).then(renderCartState); }
  /* Add = the real line appears in the drawer on the same click (built from data we already have),
     the request runs behind it and swaps in Shopify's line when it lands. No spinner, no "adding". */
  var pendingAdds = 0;
  function addToCart(body, previews){
    openCart();
    if(lastCart && previews && previews.length){
      var c = lastCart;
      previews.forEach(function(pv){
        var same = c.items.findIndex(function(x){ return x.variant_id === pv.variant_id && !Object.keys(x.properties || {}).length && !Object.keys(pv.properties || {}).length; });
        if(same > -1){ var x = c.items[same]; x.quantity += pv.quantity; x.final_line_price = (x.final_price || x.price) * x.quantity; }
        else c.items.unshift(pv);
      });
      renderCartState(retotal(c));
    }
    pendingAdds++;
    return post(N.routes.cartAdd + ".js", body).then(function(res){
      pendingAdds--;
      if(!lastCart || !res || !res.items) return fetchCart();
      var c = lastCart;
      c.items = c.items.filter(function(x){ return !x._tmp; });
      res.items.forEach(function(it){
        var i = c.items.findIndex(function(x){ return x.key === it.key; });
        if(i > -1) c.items[i] = it; else c.items.unshift(it);
      });
      renderCartState(retotal(c));
      var todo = deferredChanges.splice(0);
      if(todo.length){
        todo.forEach(function(d){ var real = c.items.filter(function(x){ return x.variant_id === d.variant_id && !x._tmp; })[0]; if(real) changeLine(real.key, d.qty); });
      } else fetchCart(); // silent reconcile (discounts, stock caps)
    }).catch(function(){ pendingAdds--; fetchCart(); });
  }
  function previewLine(variant, productTitle, image, props, handle){
    return {_tmp:true, key:"tmp-" + variant.id + "-" + Date.now(), variant_id:variant.id, handle:handle || "", product_title:productTitle,
      variant_title:variant.title || "", image:image || "", quantity:1, price:variant.price, final_price:variant.price, final_line_price:variant.price, properties:props || {}};
  }
  var deferredChanges = []; // changes made to a line that Shopify has not confirmed yet
  function changeLine(key, qty){
    if(key.indexOf("tmp-") === 0){ // line is still being added: apply locally now, send once Shopify has given it a key
      var line = lastCart && lastCart.items.filter(function(x){ return x.key === key; })[0];
      if(line){ deferredChanges.push({variant_id:line.variant_id, qty:qty}); if(qty <= 0) lastCart.items = lastCart.items.filter(function(x){ return x !== line; }); else { line.quantity = qty; line.final_line_price = line.price * qty; } renderCartState(retotal(lastCart)); }
      return Promise.resolve();
    }
    if(lastCart){ // instant: drop or update the line locally first
      var c = lastCart, idx = c.items.findIndex(function(x){ return x.key === key; });
      if(idx > -1){
        if(qty <= 0) c.items.splice(idx, 1);
        else { var unit = c.items[idx].final_price || c.items[idx].price; c.items[idx].quantity = qty; c.items[idx].final_line_price = unit * qty; }
        renderCartState(retotal(c));
      }
    }
    return post(N.routes.cartChange + ".js", {id:key, quantity:qty}).then(function(c){ if(c && c.items) renderCartState(c); else fetchCart(); });
  }
  function addVariant(id){ // cross-sell "Add": one round trip via update.js, optimistic first
    var qty = 1;
    if(lastCart){ lastCart.items.forEach(function(x){ if(x.variant_id === id && !Object.keys(x.properties || {}).length) qty = x.quantity + 1; }); }
    if(qty === 1){
      var cross = []; try { cross = JSON.parse(cartHost.getAttribute("data-cross") || "[]"); } catch(e){}
      var p = cross.filter(function(x){ return x.variant === id; })[0];
      var props = (p && isMtoText(p.vtitle)) ? {"Custom Order": mtoProp(p.handle)} : {}; // silver quick-adds carry the lead time too
      var pv = p ? [previewLine({id:id, price:p.price, title:p.vtitle || ""}, p.title, p.img ? p.img.replace(/&?width=\d+/, "") : "", props, p.handle)] : null;
      return addToCart({items:[{id:id, quantity:1, properties:props}]}, pv);
    }
    var updates = {}; updates[id] = qty;
    if(lastCart){ var c = lastCart; c.items.forEach(function(x){ if(x.variant_id === id){ x.quantity = qty; x.final_line_price = (x.final_price || x.price) * qty; } }); renderCartState(retotal(c)); }
    return post(N.routes.cart + "/update.js", {updates:updates}).then(function(c){ if(c && c.items) renderCartState(c); else fetchCart(); });
  }
  if(cartHost){
    cartHost.addEventListener("click", function(e){
      var line = e.target.closest(".ci"), key = line && line.getAttribute("data-key");
      var q = e.target.closest("[data-d]");
      if(q && key){ var cur = parseInt(line.querySelector(".qty span").textContent, 10) || 1; changeLine(key, Math.max(0, cur + parseInt(q.getAttribute("data-d"), 10))); return; }
      if(e.target.closest("[data-rm]") && key){ changeLine(key, 0); return; }
      var add = e.target.closest("[data-variant]");
      if(add){ add.disabled = true; addVariant(parseInt(add.getAttribute("data-variant"), 10)); }
    });
    $("#cartOpen") && $("#cartOpen").addEventListener("click", function(){ openCart(); fetchCart(); });
    var co = $("#checkoutBtn");
    if(co) co.addEventListener("click", function(e){
      if(!pendingAdds) return;
      e.preventDefault(); var href = co.getAttribute("href"), t0 = Date.now();
      (function wait(){ if(!pendingAdds || Date.now() - t0 > 4000) location.href = href; else setTimeout(wait, 40); })();
    });
    $("#cartClose") && $("#cartClose").addEventListener("click", closeCart);
    if(scrim) scrim.addEventListener("click", closeCart);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeCart(); });
    fetchCart();
  }

  /* ---------- product page ---------- */
  (function(){
    var root = $("#pdp"); if(!root) return;
    var product; try { product = JSON.parse(root.getAttribute("data-product")); } catch(e){ return; }
    var hasSize = root.getAttribute("data-has-size") === "true";
    var groups = $$("[data-opt]", root);
    var sel = groups.map(function(g){ var on = $('button[aria-pressed="true"]', g); return on ? on.getAttribute("data-val") : ""; });
    var sizeIdx = -1; groups.forEach(function(g,i){ if(/size|length/i.test(g.getAttribute("data-opt"))) sizeIdx = i; });
    // Shopify keeps option values in the order they were typed: sort numeric sizes ascending, "Custom" last
    groups.forEach(function(g){
      var bs = $$("button[data-val]", g);
      if(bs.length < 2 || !bs.every(function(b){ return /^\d/.test(b.getAttribute("data-val")) || /custom/i.test(b.getAttribute("data-val")); })) return;
      bs.sort(function(a,b){
        var ca = /custom/i.test(a.getAttribute("data-val")), cb = /custom/i.test(b.getAttribute("data-val"));
        if(ca !== cb) return ca ? 1 : -1;
        return parseFloat(a.getAttribute("data-val")) - parseFloat(b.getAttribute("data-val"));
      }).forEach(function(b){ g.appendChild(b); });
    });
    var atc = $("#atc"), hint = $("#needSize"), vid = $("#variantId"), cf = $("#customField"), cs = $("#customSize");
    function needsSize(){ return sizeIdx > -1 && !sel[sizeIdx]; }
    function matches(x, ignore){
      for(var i=0;i<groups.length;i++){ if(i === ignore) continue; if(sel[i] && x.options[i] !== sel[i]) return false; }
      return true;
    }
    function findVariant(){
      var hits = product.variants.filter(function(x){ return matches(x, -1); });
      var live = hits.filter(function(x){ return x.available; });
      return live[0] || hits[0] || null;
    }
    function priceOf(v){
      if(v && !needsSize()) return v.price;
      var min = null; product.variants.forEach(function(x){ if(matches(x, -1) && (min === null || x.price < min)) min = x.price; });
      return min === null ? (v ? v.price : 0) : min;
    }
    var atcLabel = atc ? atc.innerHTML : "", atcSold = atc ? atc.getAttribute("disabled") !== null : false;
    var stickyLabel = null;
    function sync(){
      var v = findVariant();
      var pr = money(priceOf(v));
      // A material can be sold out while the product still has stock in the other one, so the
      // price line answers for what is selected, not for the product. It also has to answer
      // before every option is picked: if nothing in stock matches the choices made so far,
      // the piece is sold out whether or not a size has been chosen yet.
      var anyAvail = product.variants.some(function(x){
        return x.available && sel.every(function(val, i){ return !val || x.options[i] === val; });
      });
      var soldOut = !anyAvail || (!!v && v.available === false && !needsSize());
      var sb = $("#atcSticky");
      if(sb){
        if(stickyLabel === null) stickyLabel = sb.innerHTML;
        if(soldOut){ sb.disabled = true; sb.textContent = N.strings.sold_out || "Sold out"; }
        else if(sb.disabled){ sb.disabled = false; sb.innerHTML = stickyLabel; }
      }
      var pEl = $("#pdpPrice");
      if(pEl){
        pEl.textContent = soldOut ? String(N.strings.sold_out || "Sold out").toUpperCase() : pr;
        var curEl = pEl.parentNode.querySelector(".cur"); if(curEl) curEl.hidden = soldOut;
        var taxEl = $(".taxline"); if(taxEl) taxEl.hidden = soldOut;
      }
      ["#atcPrice","#stickyPrice"].forEach(function(s){ var e = $(s); if(e) e.textContent = pr; });
      if(vid && v) vid.value = v.id;
      // keep the form's lead-time property in step, so even a native (pre-JS) submit carries it
      var mp = $("#mtoProp");
      if(mp){
        mp.value = mtoProp(product.handle);
        mp.disabled = !(v && (v.options.some(isMtoText) || (cf && !cf.hidden && cs && cs.value.trim() !== "")));
      }
      var sl = $("#stockLine");
      if(sl){
        var txt = "", cls = "";
        if(v && v.available === false && !needsSize()){ txt = "Sold out"; cls = "off"; }
        else if(v && v.options.some(isMtoText)){ var swk = mtoWeeks(product.handle); txt = "Custom order: ships in " + swk + " week" + (swk === 1 ? "" : "s"); cls = "mto"; }
        else if(v && v.available){ txt = "In stock: ready to ship"; cls = "ok"; }
        sl.hidden = !txt; sl.className = "stockline " + cls; $("span:last-child", sl).textContent = txt;
      }
      if(atc && !atcSold){
        var dead = soldOut;
        atc.disabled = dead;
        if(dead){ atc.textContent = N.strings.sold_out || "Sold out"; } else { atc.innerHTML = atcLabel; var ap = $("#atcPrice"); if(ap) ap.textContent = pr; }
        atc.classList.toggle("notready", needsSize());
      }
      groups.forEach(function(g,i){
        $$("button[data-val]", g).forEach(function(b){
          var val = b.getAttribute("data-val");
          var ok = product.variants.some(function(x){ return x.available && x.options[i] === val && matches(x, i); });
          b.classList.toggle("na", !ok);
        });
      });
      if(hint) hint.hidden = !needsSize();
      var so = $("#stickyOpts");
      if(so){ // material on its own line; size and finish under it, so nothing gets cut off
        var ov = groups.map(function(g,i){ return sel[i] || ("Pick " + g.getAttribute("data-opt").toLowerCase()); });
        so.innerHTML = '<span>' + esc(ov[0] || "") + '</span>' +
          (ov.length > 1 ? '<span>' + esc(ov.slice(1).join(" · ")) + '</span>' : "");
      }
      if(cf){ var custom = sel.some(function(v){ return /custom/i.test(v || ""); }); var was = !cf.hidden; cf.hidden = !custom; if(custom && !was && cs) cs.focus(); }
      if(typeof syncPair === "function") syncPair();
      if(typeof pairSyncButtons === "function") pairSyncButtons();
    }
    groups.forEach(function(g,i){
      g.addEventListener("click", function(e){
        var b = e.target.closest("button[data-val]"); if(!b) return;
        sel[i] = b.getAttribute("data-val");
        $$("button", g).forEach(function(x){ x.setAttribute("aria-pressed", String(x === b)); });
        sync();
        if(i === finishIdx) showFinish(sel[i]);
      });
    });
    /* ---- gallery: finish-specific photos (alt text names the finish), mobile gallery, packaging image ---- */
    var gal = $(".gallery", root), gmainHost = $(".gmain", root);
    function parse(attr){ try { return JSON.parse(root.getAttribute(attr) || "null"); } catch(e){ return null; } }
    var mediaAll = parse("data-media") || [], mobileGallery = parse("data-mobile-gallery") || [], shared = parse("data-shared");
    var isMobile = function(){ return window.innerWidth < 940; };
    var finishIdx = -1; groups.forEach(function(g,i){ if(/finish/i.test(g.getAttribute("data-opt"))) finishIdx = i; });
    var isPackaging = function(m){ return /xc_c/i.test((m.alt || "") + " " + (m.full || "")); };
    var isOnBody = function(m){ return /on-body|onbody|on_body|lifestyle/i.test((m.alt || "") + " " + (m.full || "")); };
    // gallery order: first product shot, on-body shot(s), the rest of the product shots, packaging (xc_c) last
    function packagingLast(list){
      var body = list.filter(isOnBody), pack = list.filter(function(m){ return isPackaging(m) && !isOnBody(m); });
      var shots = list.filter(function(m){ return !isOnBody(m) && !isPackaging(m); });
      return shots.slice(0, 1).concat(body, shots.slice(1), pack);
    }
    var warmSets = null; // fills in once the finish sets are known; run after the first render, when the frame has a real width
    var finishSets = {};
    if(finishIdx > -1){
      var keys = $$("button[data-val]", groups[finishIdx]).map(function(b){ return b.getAttribute("data-val"); });
      var skipList = (root.getAttribute("data-gallery-skip") || "").split(",").map(function(x){ return x.trim().toLowerCase(); }).filter(Boolean);
      var skipped = function(m){ var hay = ((m.full || "") + " " + (m.alt || "")).toLowerCase(); return skipList.some(function(x){ return hay.indexOf(x) > -1; }); };
      var seen = {}, gallerySrc = mediaAll.filter(function(m){ if(seen[m.full] || skipped(m)) return false; seen[m.full] = 1; return true; });
      // a file belongs to the finish named first in its name ("distressed-angled-polished-inside" is distressed)
      // an explicit map wins where it exists; otherwise the file name still decides
      var finMap = parse("data-finish-map") || null;
      var mappedFinish = function(m){
        if(!finMap) return null;
        var hay = ((m.full || "") + " " + (m.alt || "")).toLowerCase();
        for(var f in finMap){ if(hay.indexOf(f) > -1) return String(finMap[f]).toLowerCase(); }
        return null;
      };
      var finishOf = function(m){
        var want = mappedFinish(m);
        if(want){ for(var j = 0; j < keys.length; j++){ if(keys[j].toLowerCase() === want) return keys[j]; } }
        var best = null, at = Infinity; keys.forEach(function(k){ var i = m.alt ? m.alt.indexOf(k.toLowerCase()) : -1; if(i > -1 && i < at){ at = i; best = k; } }); return best; };
      // images that name no finish (packaging, lifestyle) belong to every finish; packaging (xc_c) always goes last
      var neutral = gallerySrc.filter(function(m){ return !finishOf(m); });
      keys.forEach(function(val){
        var list = gallerySrc.filter(function(m){ return finishOf(m) === val; });
        if(list.length) finishSets[val] = packagingLast(list.concat(neutral.filter(function(m){ return list.indexOf(m) < 0; })));
      });
      warmSets = function(){
        // run after the page has settled, one at a time and at low priority, so prefetching the
        // other finish never starves the photo on screen
        var queue = [], thumbs = [];
        Object.keys(finishSets).forEach(function(k){ finishSets[k].forEach(function(m){
          if(m.thumb && thumbs.indexOf(m.thumb) < 0) thumbs.push(m.thumb);
          var u = big(m); if(queue.indexOf(u) < 0) queue.push(u);
        }); });
        thumbs.forEach(function(u){ warmFull(u, "low"); }); // a few KB each, and they are the layer the frame shows first

        var next = function(){
          var u = queue.shift(); if(!u) return;
          if(fullCache[u]) return next();
          var im = warmFull(u, "low");
          if(im.complete) next(); else { im.addEventListener("load", next, {once:true}); im.addEventListener("error", next, {once:true}); }
        };
        var start = function(){ (window.requestIdleCallback || function(f){ setTimeout(f, 300); })(next); };
        if(document.readyState === "complete") start(); else window.addEventListener("load", start, {once:true});
      };
    }
    var fullCache = {};
    function warmFull(u, priority){
      if(!u) return null;
      if(!fullCache[u]){
        var i = new Image();
        try { if(priority) i.fetchPriority = priority; } catch(e){}
        i.src = u; fullCache[u] = i;
        try { if(i.decode) i.decode().catch(function(){}); } catch(e){}
      }
      return fullCache[u];
    }
    function sameFile(a, b){
      var f = function(u){ return String(u || "").split("?")[0].split("/").pop(); };
      return !!a && f(a) === f(b);
    }
    /* ---- gallery: one track of slides, moved with a single transform (drag follows the finger, release snaps to a slide) ---- */
    var gIdx = 0, gCount = 0, track = null;
    // the browser picks the file off the srcset; src is only the fallback, and full-frame photos start from the larger one
    var fillFrame = !!root.getAttribute("data-gallery-fill");
    var cutout = root.getAttribute("data-cutout") || ""; // the no-background shot, for the bundle rows
    var cutouts = parse("data-cutouts") || {}; // ...and one per finish, so each bundle row shows its own piece
    /* Pick one exact file for the frame and use it everywhere. Letting srcset choose meant the
       warm cache fetched one URL and the slide asked for another, so switching finish hit an
       empty cache and showed a blank frame while it downloaded. */
    var big = function(m){
      var w = (gmainHost ? gmainHost.clientWidth : 0) || (isMobile() ? 400 : 620);
      var need = w * (window.devicePixelRatio || 1);
      if(need <= 700) return m.mid || m.full;      // the step above is always comfortably
      if(need <= 1100) return m.full || m.mid;      // wider than the frame, so a pinch zoom
      if(need <= 1500) return m.xl || m.full || m.mid; // or a wider window stays sharp
      return m.xxl || m.xl || m.full || m.mid;
    };
    function gW(){ return gmainHost ? gmainHost.clientWidth : 0; }
    function setTrack(px){ if(track) track.scrollLeft = px; }
    function markActive(i){
      gIdx = i;
      $$(".gslide img:not(.gph)", gmainHost).forEach(function(im, k){ if(k === i) im.id = "gmain"; else im.removeAttribute("id"); });
      $$(".gdots i", gmainHost).forEach(function(d, k){ d.className = k === i ? "on" : ""; });
      $$("#gthumbs button", gal).forEach(function(x, k){ x.setAttribute("aria-pressed", String(k === i)); });
    }
    function goTo(i, animate){
      if(!track || !gCount) return; i = Math.max(0, Math.min(gCount - 1, i)); markActive(i);
      var left = i * gW(), from = track.scrollLeft, d = left - from;
      if(animate === false || !d){ track.scrollLeft = left; return; }
      // own ease-out (smooth scrollTo is unreliable inside a snap container); the end point is a snap point so the strip settles cleanly
      var ms = Math.max(260, Math.min(560, Math.round(Math.abs(d) / Math.max(1, gW()) * 420 + 200))), t0 = performance.now(), tok = ++scrollTok;
      track.style.scrollSnapType = "none"; // snapping would pull every in-between frame back to a slide; re-enabled once we land exactly on one
      var step = function(now){
        if(tok !== scrollTok){ track.style.scrollSnapType = ""; return; }
        var p = Math.min(1, (now - t0) / ms), e = 1 - Math.pow(1 - p, 3); track.scrollLeft = from + d * e;
        if(p < 1) requestAnimationFrame(step); else { track.scrollLeft = left; track.style.scrollSnapType = ""; }
      };
      requestAnimationFrame(step);
      setTimeout(function(){ if(tok === scrollTok){ track.scrollLeft = left; track.style.scrollSnapType = ""; } }, ms + 120); // frames stop in a background tab: land it anyway
    }
    var scrollTok = 0;
    function renderGallery(list){
      if(!gal || !list || !list.length) return;
      list = packagingLast(list);
      if(isMobile() && shared && !list.some(isPackaging)) list = list.concat([shared]);
      gCount = list.length;
      var firstSrc = ($("#gmain") || {}).currentSrc || "";
      gmainHost.innerHTML = '<div class="gtrack">' + list.map(function(m, i){
        var src = big(m);
        if(i === 0 && firstSrc && sameFile(firstSrc, src)) src = firstSrc; // the first image is already decoded on screen
        // the thumbnail sits underneath: it is already decoded, so the frame shows the photo at once and sharpens as the full file lands
        return '<div class="gslide">'
          + (m.thumb ? '<img class="gph" src="' + esc(m.thumb) + '" alt="" aria-hidden="true" decoding="async" draggable="false">' : '')
          + '<img' + (i === 0 ? ' id="gmain"' : '') + ' src="' + esc(src) + '" alt="' + esc(product.title) + '" loading="eager" fetchpriority="' + (i < 2 ? 'high' : 'auto') + '" decoding="async" draggable="false"></div>';
      }).join("") + '</div>';
      if(list.length > 1){
        var dots = document.createElement("div"); dots.className = "gdots"; dots.setAttribute("aria-hidden", "true");
        dots.innerHTML = list.map(function(_, i){ return '<i' + (i === 0 ? ' class="on"' : '') + '></i>'; }).join("");
        gmainHost.appendChild(dots);
      }
      track = $(".gtrack", gmainHost); gIdx = 0; track.scrollLeft = 0;
      // the strip is a native horizontal scroller with snap points (buttery on iOS); keep the thumbnails in step with it
      track.addEventListener("touchstart", function(){ scrollTok++; }, {passive:true});
      var tick = false; track.addEventListener("scroll", function(){ if(tick) return; tick = true; requestAnimationFrame(function(){ tick = false; var i = Math.round(track.scrollLeft / Math.max(1, gW())); if(i !== gIdx && i >= 0 && i < gCount) markActive(i); }); }, {passive:true});
      list.forEach(function(m, i){ var im = warmFull(big(m), i < 2 ? "high" : "low"); if(i < 2) try { im.fetchPriority = "high"; } catch(e){} });
      var old = $("#gthumbs", gal); if(old) old.remove();
      if(list.length > 1){
        var t = document.createElement("div"); t.className = "gthumbs"; t.id = "gthumbs"; t.setAttribute("role", "group"); t.setAttribute("aria-label", "Product images");
        t.innerHTML = list.map(function(m, i){ return '<button type="button" data-src="' + esc(big(m)) + '" aria-pressed="' + (i === 0) + '" aria-label="View ' + (i + 1) + '"><img src="' + esc(m.thumb) + '" loading="' + (i < 8 ? 'eager' : 'lazy') + '" decoding="async" alt=""></button>'; }).join("");
        gal.appendChild(t);
      }
    }
    if(finishIdx > -1 && sel[finishIdx] && finishSets[sel[finishIdx]]) renderGallery(finishSets[sel[finishIdx]]);
    else if(isMobile() && mobileGallery.length) renderGallery(mobileGallery);
    else { var cur = $$("#gthumbs button", gal).map(function(b){ return {full:b.getAttribute("data-src"), mid:b.getAttribute("data-mid") || b.getAttribute("data-src"), xl:b.getAttribute("data-xl") || b.getAttribute("data-src"), xxl:b.getAttribute("data-xxl") || "", thumb:$("img", b).getAttribute("src")}; }); if(cur.length > 1) renderGallery(cur); } // applies the gallery order (on-body second, packaging last) on every screen
    if(warmSets) warmSets(); // every finish's photos are in cache before anyone taps one
    function showFinish(val){
      var list = finishSets[val]; if(!list) return;
      var swap = function(){
        renderGallery(list);
        if(isMobile()) scrollToY(Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerOffset() - 12), 320); // desktop gallery is sticky, nothing to scroll
      };
      // hold the photo that is on screen until the new one can paint, rather than swapping to an empty frame
      var ordered = packagingLast(list);
      var first = ordered.length ? warmFull(big(ordered[0])) : null;
      if(!first || first.complete){ swap(); return; }
      var done = false, go = function(){ if(done) return; done = true; swap(); };
      first.addEventListener("load", go, {once:true});
      first.addEventListener("error", go, {once:true});
      setTimeout(go, 250); // the slide shows its thumbnail meanwhile, so there is nothing to wait around for
    }
    function warmGallery(){ $$("#gthumbs button", gal).forEach(function(x){ warmFull(x.getAttribute("data-src")); }); }
    if(gal){ warmGallery(); window.addEventListener("load", warmGallery); }
    window.addEventListener("resize", function(){ if(track) track.scrollLeft = gIdx * gW(); });
    if(gal) gal.addEventListener("click", function(e){
      var b = e.target.closest("#gthumbs button"); if(!b) return;
      var bs = $$("#gthumbs button", gal), i = bs.indexOf(b);
      if(track){ goTo(i, true); }
      else { var m = $("#gmain"); if(m){ m.removeAttribute("srcset"); m.removeAttribute("sizes"); m.src = b.getAttribute("data-src"); } bs.forEach(function(x){ x.setAttribute("aria-pressed", String(x === b)); }); }
      b.blur();
    });
    /* ---- both-finishes bundle ---- */
    /* compact bundle offer: header row selects it, the body carries a size per finish */
    var pair = $("#pairBundle"), pairHead = $("#pairHead"), pairRows = $("#pairRows");
    var pairIdx = -1, pairVals = [], pairOn = false, pairSizes = [], pairTouched = [], pairCustom = [];
    if(pair){
      var want = (pair.getAttribute("data-pair-opt") || "finish").toLowerCase();
      groups.forEach(function(g,i){ if(g.getAttribute("data-opt").toLowerCase() === want) pairIdx = i; });
      if(pairIdx > -1) pairVals = $$("button[data-val]", groups[pairIdx]).map(function(b){ return b.getAttribute("data-val"); });
    }
    function pairVariant(finish, size){ // one bundle line: this finish, this size, everything else as chosen above
      return product.variants.filter(function(x){
        if(x.options[pairIdx] !== finish) return false;
        if(sizeIdx > -1 && size && x.options[sizeIdx] !== size) return false;
        for(var i=0;i<groups.length;i++){
          if(i === pairIdx || i === sizeIdx) continue;
          if(sel[i] && x.options[i] !== sel[i]) return false;
        }
        return true;
      }).filter(function(x){ return x.available; })[0] || null;
    }
    function isCustomSize(v){ return /custom/i.test(String(v || "")); }
    function pairSizeList(finish){ // every size this finish can actually be made in, custom included
      if(sizeIdx < 0) return [];
      return $$("button[data-val]", groups[sizeIdx]).map(function(b){ return b.getAttribute("data-val"); })
        .filter(function(s){ return pairVariant(finish, s); });
    }
    function pairSettle(){ // each line follows the size chosen above until the customer picks its own
      pairVals.forEach(function(f, i){
        var list = pairSizeList(f);
        if(!list.length){ pairSizes[i] = null; return; }
        var main = sizeIdx > -1 ? sel[sizeIdx] : null;
        if(!pairTouched[i] && main && list.indexOf(main) > -1) pairSizes[i] = main;
        if(!pairSizes[i] || list.indexOf(pairSizes[i]) < 0) pairSizes[i] = list[0];
      });
    }
    function pairVariants(){
      if(!pair || pairIdx < 0 || pairVals.length !== 2) return null;
      var out = pairVals.map(function(f, i){ return pairVariant(f, pairSizes[i]); });
      return out.every(Boolean) ? out : null;
    }
    function pairPrices(vs){
      var pct = parseInt(pair.getAttribute("data-pct"), 10) || 0;
      var was = vs[0].price + vs[1].price;
      return {was:was, now:Math.round(was * (100 - pct) / 100)};
    }
    function syncPair(){
      if(!pair) return;
      pairSettle();
      var vs = pairVariants();
      if(!vs){ pair.hidden = true; pairOn = false; pairHead.setAttribute("aria-pressed", "false"); pairRows.hidden = true; return; }
      var p = pairPrices(vs);
      $("#pairNow").textContent = money(p.now);
      $("#pairWas").textContent = money(p.was);
      $("#pairSave").textContent = "Save " + money(p.was - p.now);
      pairRows.innerHTML = vs.map(function(v, i){
        var set = finishSets[pairVals[i]];
        var img = cutouts[String(pairVals[i]).toLowerCase()] || cutout || (set && set[0] && (set[0].thumb || set[0].full)) || (v.featured_image && v.featured_image.src) || "";
        var list = pairSizeList(pairVals[i]);
        var opts = list.map(function(s){
          return '<option value="' + esc(s) + '"' + (s === pairSizes[i] ? ' selected' : '') + '>' + esc(s) + '</option>';
        }).join("");
        return '<div class="po-row">' +
          '<span class="po-th">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span>' +
          '<span class="po-rt">1&times; ' + esc(pairVals[i]) + '<small>' + esc(money(v.price)) + '</small></span>' +
          (list.length ? '<select class="po-size" data-i="' + i + '" aria-label="Size, ' + esc(pairVals[i]) + '">' + opts + '</select>' : '') +
          '</div>' +
          (isCustomSize(pairSizes[i]) ? '<div class="po-cw"><input type="text" class="po-custom" data-i="' + i + '" maxlength="60" autocomplete="off" ' +
            'placeholder="' + esc(N.strings.customSize || "Enter your custom size here") + '" ' +
            'aria-label="Custom size, ' + esc(pairVals[i]) + '" value="' + esc(pairCustom[i] || "") + '"></div>' : '');
      }).join("");
      pairRows.hidden = !pairOn;
      pair.hidden = false;
    }
    function pairSyncButtons(){ // while the offer is on, both buy buttons speak for the bundle
      if(!pair || !pairOn) return;
      var vs = pairVariants(); if(!vs) return;
      var p = pairPrices(vs), saved = p.was - p.now;
      if(atc && !atc.disabled){
        atc.innerHTML = esc(pair.getAttribute("data-btn") || "Buy now") + '<span class="btn-sep">-</span><span id="atcPrice">' + esc(money(p.now)) + '</span>' +
          (saved > 0 ? '<s class="btn-was">' + esc(money(p.was)) + '</s>' : '');
      }
      var sp = $("#stickyPrice"); if(sp) sp.textContent = money(p.now);
    }
    if(pairHead) pairHead.addEventListener("click", function(){
      if(!pairVariants()) return;
      pairOn = !pairOn;
      pairHead.setAttribute("aria-pressed", String(pairOn));
      pairHead.setAttribute("aria-expanded", String(pairOn));
      pairRows.hidden = !pairOn;
      sync();
    });
    if(pairRows) pairRows.addEventListener("change", function(e){
      var s = e.target.closest("select.po-size"); if(!s) return;
      var i = parseInt(s.getAttribute("data-i"), 10);
      pairSizes[i] = s.value; pairTouched[i] = true;
      sync();
      if(isCustomSize(pairSizes[i])){ var f = pairRows.querySelector('input.po-custom[data-i="' + i + '"]'); if(f) f.focus(); }
    });
    if(pairRows) pairRows.addEventListener("input", function(e){ // held in state, so a re-render never loses it
      var f = e.target.closest("input.po-custom"); if(!f) return;
      pairCustom[parseInt(f.getAttribute("data-i"), 10)] = f.value;
      f.style.borderColor = "";
    });
    function tryAdd(){
      var props = {};
      // the bundle carries its own sizes, so it does not wait on the size buttons above
      var pvs = pairOn ? pairVariants() : null;
      if(pvs){
        var missing = -1;
        var bprops = pvs.map(function(x, i){
          var p = {};
          if(isCustomSize(pairSizes[i])){
            var typed = (pairCustom[i] || "").trim();
            if(typed) p["Custom Size"] = typed; else if(missing < 0) missing = i;
          }
          if(x.options.some(isMtoText) || p["Custom Size"]) p["Custom Order"] = mtoProp(product.handle);
          return p;
        });
        if(missing > -1){ // a custom line needs its measurement before it can go in
          var f = pairRows.querySelector('input.po-custom[data-i="' + missing + '"]');
          if(f){ f.focus(); f.style.borderColor = "var(--accent)"; }
          return;
        }
        addToCart({items: pvs.map(function(x, i){ return {id:x.id, quantity:1, properties:bprops[i]}; })},
          pvs.map(function(x, i){ var set = finishSets[pairVals[i]]; return previewLine(x, product.title, set && set[0] ? set[0].thumb : ($("#gmain") ? $("#gmain").src : ""), bprops[i], product.handle); }));
        return;
      }
      if(needsSize()){
        var g = groups[sizeIdx]; g.scrollIntoView({behavior:"smooth", block:"center"});
        $$("button", g).forEach(function(b){ b.classList.remove("pulse"); void b.offsetWidth; b.classList.add("pulse"); });
        return;
      }
      if(cf && !cf.hidden && cs && !cs.value.trim()){ cs.focus(); cs.style.borderColor = "var(--accent)"; return; }
      var v = findVariant(); if(!v || !v.available) return;
      if(cf && !cf.hidden && cs && cs.value.trim()){ props["Custom Size"] = cs.value.trim(); }
      if(v.options.some(isMtoText) || props["Custom Size"]) props["Custom Order"] = mtoProp(product.handle);
      addToCart({items:[{id:v.id, quantity:1, properties:props}]}, [previewLine(v, product.title, $("#gmain") ? $("#gmain").src : "", props, product.handle)]);
    }
    var form = $("#product-form");
    if(form) form.addEventListener("submit", function(e){ e.preventDefault(); tryAdd(); });
    var sticky = $("#atcSticky"); if(sticky) sticky.addEventListener("click", tryAdd);
    if(atc && !atc.disabled){
      // the sticky bar only appears once the shopper has scrolled past the add-to-cart button (never over the gallery on first load)
      // observer root = everything from the header line downwards, so the button "intersects" whenever it is in view or below,
      // and stops intersecting only once it has scrolled up past the header (works without scroll events and cannot miss a fast flick)
      var stickyEl = $("#sticky"); if(stickyEl){ var setH = function(){ document.documentElement.style.setProperty("--stickyh", stickyEl.offsetHeight + "px"); }; setH(); window.addEventListener("resize", setH); }
      if("IntersectionObserver" in window){
        new IntersectionObserver(function(en){ var s = $("#sticky"); if(s){ s.classList.toggle("on", !en[0].isIntersecting); document.body.classList.toggle("has-sticky", !en[0].isIntersecting); } },
          {rootMargin:"-" + headerOffset() + "px 0px 100000px 0px", threshold:0}).observe(atc);
      }
    }
    sync();
  })();
})();
